import React from 'react';
import './AppPromo.scss';
import { useAnimateOnScroll } from '../../Utils/hooks/useAnimateOnScroll';

import phoneImage from '../../Assets/images/app_promo_phone.png';
import appleStoreBadge from '../../Assets/images/app_promo_apple_store.png';
import googlePlayBadge from '../../Assets/images/app_promo_google_play.png';

const AppPromo = () => {
  const sectionRef = useAnimateOnScroll();
  const imageRef = useAnimateOnScroll();
  const textRef = useAnimateOnScroll();

  return (
    <section ref={sectionRef} className="app-promo slide-up">
      <div className="container app-promo__inner">
        <div ref={imageRef} className="app-promo__col-image scale-in">
          <img
            src={phoneImage}
            alt="HaulSync Driver App on mobile"
            className="app-promo__phone-img"
          />
        </div>

        <div ref={textRef} className="app-promo__col-text right-in">
          <h2 className="app-promo__title">
            Built for{' '}
            <span className="app-promo__title-highlight">Drivers</span>
            {' '}on the Move
          </h2>

          <p className="app-promo__description">
            Accept jobs, track routes, and manage your work — all from one
            simple app. Stay updated in real time and keep every delivery on
            track without the hassle.
          </p>

          <div className="app-promo__badges">
            <button
              type="button"
              className="app-promo__badge-link"
              aria-label="Download on the App Store"
            >
              <img
                src={appleStoreBadge}
                alt="Download on the App Store"
                className="app-promo__badge-img"
              />
            </button>
            <button
              type="button"
              className="app-promo__badge-link"
              aria-label="Get it on Google Play"
            >
              <img
                src={googlePlayBadge}
                alt="Get it on Google Play"
                className="app-promo__badge-img"
              />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppPromo;
